/**
 * Balance still collectible via Razorpay payment link on booking-confirmed dialog.
 */
export function computeAmountDueForPaymentLink({
  total = 0,
  paymentMethod = '',
  paymentType = '',
  paymentAmount = 0,
  collectAdvance = false,
  advanceAmount = 0,
  isWalkIn = true,
}) {
  const toCurrencyAmount = (value) => Math.round((Number(value) || 0) * 100) / 100;
  const bookingTotal = toCurrencyAmount(total);
  if (bookingTotal <= 0) return 0;

  const recorded = isWalkIn
    ? toCurrencyAmount(paymentAmount)
    : toCurrencyAmount(advanceAmount);

  if (paymentMethod === 'PAYMENT LINK') {
    return recorded > 0 ? recorded : bookingTotal;
  }

  if (isWalkIn) {
    if (paymentType === 'due') return bookingTotal;
    return toCurrencyAmount(Math.max(0, bookingTotal - recorded));
  }

  if (!collectAdvance || recorded <= 0) return bookingTotal;
  return toCurrencyAmount(Math.max(0, bookingTotal - recorded));
}
